import bookMarks from "../../apis/bookMarks";

export default {
  SaveBookmark({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await bookMarks.SaveBookmark(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  GetBookmarks({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await bookMarks.GetBookmarks(payload);

        commit("GET_BOOK_MARKS", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  DeleteBookmark({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await bookMarks.DeleteBookmark(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
